






























import { Component, Prop, Vue } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { InputInterface } from '../types/Exa_Input'

@Component({
    components: {
        FontAwesomeIcon
    }
})
export default class InputCheckBox extends Vue {
    @Prop() private libelle!: string
    @Prop() private description!: string
    @Prop() private value!: any
    @Prop() private ident!: any
    @Prop() private requis!: boolean
    @Prop() private disabled!: boolean
    @Prop() mode_lecture!: boolean
    @Prop() condition!: InputInterface
    @Prop({ default: false }) check_validation!: boolean

    /** 
     * inputHandler 
     * Gère les événements d'entrée en émettant un événement 'input' avec les données appropriées. 
     * @param {any} e - L'événement d'entrée. 
     */
    inputHandler(e: any) {
        this.$emit('input', { ident: this.ident, value: e.target.checked })
    }
}
